import AdminLayout from '@/layouts/Admin/AdminLayout.vue';

import DashboardHome from '@/views/Dashboard/Home.vue';

import LeadQueueApiCallsIndex from '@/views/LeadQueue/LeadQueueApiCallsIndex.vue';

import Helpdesk from '@/views/Helpdesk/Helpdesk.vue';
import OpsTickets from '@/views/Helpdesk/OpsTickets.vue';
import HelpdeskOpsTickets from '@/views/Helpdesk/HelpdeskOpsTickets.vue';

import OutboundCustomerTestIndex from '@/views/Tickets/OutboundCustomers/OutboundCustomerTestIndex.vue';

import FileManagementLayout from '@/views/FileManagement/FileManagementLayout.vue';
import NACHAReturnsIndex from '@/views/FileManagement/NACHAReturns/NACHAReturnsIndex.vue';
import NACHAConversionsIndex from '@/views/FileManagement/NACHAConversions/NACHAConversionsIndex.vue';

import OfferLookup from '@/views/OfferLookup/OfferLookup.vue';
import PrescreenProspectIndex from '@/views/PrescreenProspect/PrescreenProspectIndex.vue';

// Split Routes
import ticketRoutes from './ticketRoutes';
import settingsRoutes from './settingsRoutes';
import lendingStrategyRoutes from './lendingStrategyRoutes';
import reportRoutes from './reportRoutes';
import lpCustomerRoutes from './lpCustomerRoutes';
import leadRoutes from './leadRoutes';
import complianceRoutes from './complianceRoutes';
import userRoutes from './userRoutes';
import devToolsRoutes from './devToolsRoutes';
import abTestingRoutes from './abTestingRoutes';

export default {
  path: '/',
  component: AdminLayout,
  name: 'admin',
  children: [
    {
      path: 'dashboard',
      name: 'dashboard-home',
      component: DashboardHome,
      meta: {
        title: 'Dashboard',
      },
    },
    {
      path: 'lead-queue/:id',
      name: 'lead-queue-show',
      component: LeadQueueApiCallsIndex,
      meta: {
        title: 'Lead Queue API Calls',
        permission: 'view queue',
      },
    },
    ...abTestingRoutes,
    ...ticketRoutes,
    ...settingsRoutes,
    ...lendingStrategyRoutes,
    ...reportRoutes,
    ...leadRoutes,
    ...lpCustomerRoutes,
    ...userRoutes,
    ...complianceRoutes,

    {
      path: 'support/outbound-customer',
      name: 'support-outbound-customer',
      component: OutboundCustomerTestIndex,
      meta: {
        title: 'Outbound Customer',
        permission: 'view support-test-suite',
      },
    },
    {
      path: 'support/prospect',
      name: 'prescreen-prospect',
      component: PrescreenProspectIndex,
      meta: {
        title: 'Prescreen Prospects',
        permission: 'view support-test-suite',
      },
    },
    {
      path: 'file-management',
      name: 'file-management',
      component: FileManagementLayout,
      meta: {
        title: 'File Management',
      },
      children: [
        {
          path: 'nacha-returns',
          name: 'nacha-returns',
          component: NACHAReturnsIndex,
          meta: {
            title: 'NACHA Returns',
            permission: 'view file-management::nacha-return',
          },
        },
        {
          path: 'nacha-conversions',
          name: 'nacha-conversions',
          component: NACHAConversionsIndex,
          meta: {
            title: 'NACHA Conversions',
            permission: 'view file-management::nacha-conversion',
          },
        },
      ],
    },
    {
      path: 'offer-lookup',
      name: 'offer-lookup',
      component: OfferLookup,
      meta: {
        title: 'Offer Lookup',
        permission: 'view dev-menu',
      },
    },
    {
      path: 'helpdesk-ops-tickets',
      name: 'helpdesk-ops-tickets',
      component: HelpdeskOpsTickets,
      meta: {
        title: 'Helpdesk and Ops Tickets',
        permission: 'view jira-tickets',
      },
      children: [
        {
          path: 'helpdesk',
          name: 'helpdesk',
          component: Helpdesk,
          meta: {
            title: 'Helpdesk',
            permission: 'view jira-tickets',
          },
        },
        {
          path: 'ops-ticket',
          name: 'ops-ticket',
          component: OpsTickets,
          meta: {
            title: 'Ops Tickets',
            permission: 'view ops_tickets::dashboard',
          },
        },
      ],
    },

    ...devToolsRoutes,
  ],
};
